import { render, staticRenderFns } from "./AddVipToUserModal.vue?vue&type=template&id=37625ec7"
import script from "./AddVipToUserModal.vue?vue&type=script&lang=js"
export * from "./AddVipToUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports